import "components/scroll-to-top/scroll-to-top.scss";
import * as scrollToTop from "components/scroll-to-top/scroll-to-top-util";

//let templates or other js overwrite the parent for the button
let scrollAnchor;
if (typeof scrollToTopParent === "undefined") {
  scrollAnchor = document.getElementById("main");
} else scrollAnchor = scrollToTopParent;

// create button and add to html
const button = scrollToTop.default("main", scrollAnchor);

//making the scroll button appear when ~2 page heights have been scrolled
let options = {
  root: null,
  rootMargin: "200% 0% 0% 0%",
  threshold: 1,
};

function callback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      button.classList.remove("scrollToTop--visible");
    } else {
      button.classList.add("scrollToTop--visible");
    }
  });
}
let observer = new IntersectionObserver(callback, options);
const target = document.getElementById("js-siteHeader");
observer.observe(target);
